import { ChangeDetectionStrategy, Component } from '@angular/core';

// The Radio test card's body on the Test UI Components page: a cs-radio group, and one whose options
// are both disabled.
@Component({
  selector: 'cs-test-radio-card',
  host: { class: 'showcase-card-body' },
  template: `
    <cs-item-list>
      <cs-item-list-header data-test="radio-test-header">Radio test</cs-item-list-header>
      <cs-radio-group [(selected)]="testRadio" data-test="radio-group">
        <cs-radio [value]="true" data-test="radio-enable">Enable something</cs-radio>
        <cs-radio [value]="false" data-test="radio-disable">Disable something</cs-radio>
      </cs-radio-group>
      <cs-item-list-header data-test="radio-disabled-header">Disabled radio options</cs-item-list-header>
      <cs-radio-group [(selected)]="testRadioDisabled" data-test="radio-group-disabled">
        <cs-radio [value]="true" [(disabled)]="disabledRadio1" data-test="radio-disabled-selected">Disabled
        selected</cs-radio>
        <cs-radio [value]="false" [(disabled)]="disabledRadio2" data-test="radio-disabled-unselected">Disabled
        unselected</cs-radio>
      </cs-radio-group>
    </cs-item-list>
  `,
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CsTestRadioCardComponent {
  testRadio = true;
  testRadioDisabled = true;
  disabledRadio1 = true;
  disabledRadio2 = true;
}
